import React from 'react';
import { Button, Row, Col, Input } from 'reactstrap';
import { DebounceInput } from 'react-debounce-input';
import SelectComponent from '@componentes/select/select.component';
import { arquivamentoManualTipoOptions } from '../../../../../arquivamento.utils';
import IntlMessage from '../../../../../../../helpers/intlMessage';
import { useIntl } from 'react-intl';

function Filtros (props) {
  const intl = useIntl()
  return (
    <Row className='mv-arquivamento-page'>
      <Col sm={'3'} style={{paddingRight: '0px'}}>
        <SelectComponent
          options={arquivamentoManualTipoOptions}
          value={props.tipoSelecionado}
          onChange={e => props.onChageTipo(e)}
          placeholder={`${intl.formatMessage({id:"general.materialArchiving.materialType"})}`}
          styles={{borderColor: 'transparent'}}
          disabled={props.carregando}
        />
      </Col>
      <Col sm={'auto'} style={{paddingRight: '0px'}}>
        <Input
          placeholder={`${intl.formatMessage({id:"general.materialArchiving.examNumber"})}`}
          style={{height: '45px', borderRadius: '5px', fontSize: '13px'}}
          onChange={props.onChangeNumeroExame}
          onKeyPress={props.onKeyPressNumeroExame}
          value={props.numeroDoExame}
          disabled={props.carregando}
        />
      </Col>
      <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'auto', width: 'auto', paddingRight: '0px'}}>
        <div className="label-data"><IntlMessage id="period.name"/></div>
        <div className="form-group has-float-label" style={{width: '200px', display: 'block'}}>
          <SelectComponent
            isClearable
            className="filtro-data"
            noOptionsMessage={() => {return intl.formatMessage({id: "dashboards.reports.noItemsFound"})}}
            name="form-field-period"
            placeholder={`${intl.formatMessage({id: "dashboards.general.selectPeriod"})}`}
            value={props.periodo}
            onChange={(e) => {
              props.onChangePeriodo(e);
              e && e.value ? props.mudarIntervaloPeriodo(e.value) : props.mudarIntervaloPeriodo('todos');
            }}
            options={props.periodos}
          />
        </div>
        {props.periodo && props.periodo.value === 'outro' && (
          <React.Fragment>
            <DebounceInput
              name="periodoDe"
              type="date"
              style={{width: '130px', display: 'block'}}
              className="filtro-data"
              value={props.dataInicial}
              onChange={(value) => {props.onChangeData('dataInicial', value.target.value)}}
              onKeyPress={(e) => props.onKeyPressData(e)}
            />
            <DebounceInput
              name="periodoAte"
              type="date"
              style={{width: '130px', display: 'block'}}
              className="filtro-data"
              value={props.dataFinal}
              onChange={(value) => {props.onChangeData('dataFinal', value.target.value)}}
              onKeyPress={(e) => props.onKeyPressData(e)}
            />
          </React.Fragment>
        )}

      </div>
      <Col sm={1}>
        <Button
          className='btn btn-primary'
          onClick={props.onClickFiltrar}
          style={{height: '38px', width: '38px'}}
          disabled={props.carregando}
        >
          <i className='icons-btn mv-basico-pesquisar'></i>
        </Button>
      </Col>
    </Row>
  );
}

export default Filtros;



// WEBPACK FOOTER //
// ./src/pages/arquivamento/tabs/Arquivamento/modais/ArquivamentoManual/Filtros/index.js